// extracted by mini-css-extract-plugin
module.exports = {"productCardContainer":"FeaturedProductCards_productCardContainer__1P7K1","oneSlide":"FeaturedProductCards_oneSlide__2udHK"};